import React, { useMemo } from "react";

// Folder-browse chrome (Finder/Explorer): a breadcrumb + folder tiles. The document LISTING itself
// is delegated to the normal search-results view (list/grid toggle, hover preview, chips, tags,
// date, pages) by running the folder filter {"FolderId":{"$eq":id}} — so browse looks like search.
const FX_TILE = {
  display: "flex", flexDirection: "column", alignItems: "center", gap: 8, width: 104,
  padding: "14px 8px", border: "1px solid transparent", borderRadius: 10,
  background: "transparent", cursor: "pointer", textAlign: "center",
};
const FX_NAME = { fontSize: 12, color: "#374151", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block", lineHeight: 1.3 };
export function FolderTile({ folder, onOpen }) {
  const hover = (on) => (e) => { e.currentTarget.style.background = on ? "#f3f4f6" : "transparent"; };
  return (
    <button style={FX_TILE} title={folder.path} onClick={onOpen} onMouseEnter={hover(true)} onMouseLeave={hover(false)}>
      <svg width="44" height="44" viewBox="0 0 24 24" fill="#aebde0" stroke="#8497c4" strokeWidth="0.75"><path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/></svg>
      <span style={FX_NAME}>{folder.name}</span>
    </button>
  );
}
export function FolderBreadcrumb({ cwd, folders, onNav, t }) {
  const byId = useMemo(() => { const m = new Map(); folders.forEach((f) => m.set(f.id, f)); return m; }, [folders]);
  const crumbs = useMemo(() => {
    const chain = []; let c = cwd != null ? byId.get(cwd) : null;
    while (c) { chain.unshift(c); c = c.parentId != null ? byId.get(c.parentId) : null; }
    return chain;
  }, [cwd, byId]);
  const link = (active) => ({ border: "none", background: "none", cursor: "pointer", color: active ? "#111827" : "#4338ca", fontWeight: 600, padding: 0, fontSize: 14 });
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
      <button onClick={() => onNav(null)} style={link(cwd == null)}>{t("explorer.home", { defaultValue: "Folders" })}</button>
      {crumbs.map((c) => (
        <React.Fragment key={c.id}>
          <span style={{ color: "#9ca3af" }}>›</span>
          <button onClick={() => onNav(c.id)} style={link(c.id === cwd)}>{c.name}</button>
        </React.Fragment>
      ))}
    </div>
  );
}
